var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87084 1.88739L6.50001 2.68854L7.12918 1.88739C8.21189 0.508726 10.2462 0.425233 11.4332 1.72753C12.4556 2.84927 12.4556 4.58986 11.4332 5.7116C11.4332 5.71161 11.4332 5.71161 11.4332 5.71162L6.50001 11.1238L1.56684 5.7116L1.56684 5.71159C0.544388 4.58986 0.544386 2.84927 1.56684 1.72753L1.56684 1.72753C2.75387 0.42523 4.78814 0.508728 5.87084 1.88739Z",
    stroke: "white",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.62bcd2d4c55e011a33cb9014df164f58.svg";
export { ForwardRef as ReactComponent };